// Suppress ResizeObserver errors at the window level
// These are harmless warnings that occur with Ant Design components
// The root cause has been fixed (Form.useWatch with empty array removed)
// This file serves as a backup suppression

const errorHandler = (event: ErrorEvent) => {
  if (
    event.message?.includes('ResizeObserver loop') ||
    event.message?.includes('ResizeObserver limit')
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
};

window.addEventListener('error', errorHandler);

export {};
